import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import i18n from 'i18next';
import ShareIcon from '@material-ui/icons/Share';
import ShareIconButton from '../ShareIconButton';
import DialogShareButtonGroup from 'components/common/Dialog/DialogShareButtonGroup';
import DialogSystem from 'client/components/DialogSystem';
import { system900, system300 } from 'Mui/styles/color';

const OtherShareButton = ({
    title = '',
    text = '',
    url = '',
    color = system900.color,
    variant = 'contained',
    isFetchingData
}) => {
    const { pathname } = useLocation();

    const isEditor = pathname.includes('/edit');
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState(false);
    const shareData = {
        title,
        text,
        url
    };
    const canUseShare =
        navigator.canShare && navigator.canShare(shareData) && /Mobi/i.test(navigator.userAgent);

    const handleShare = async () => {
        if (canUseShare) {
            try {
                await navigator.share(shareData).catch(err => {
                    const { name } = err;
                    if (name === 'NotAllowedError') {
                        setShowError(true);
                    }
                });
            } catch (error) {
                setOpen(true);
            }
        } else {
            setOpen(true);
        }
    };
    return (
        <>
            <ShareIconButton
                variant={variant}
                text={i18n.t('btn.other')}
                textColor={color}
                bgColor="#ffffff"
                icon={ShareIcon}
                size={28}
                onClick={handleShare}
                style={otherButtonStyle(variant)}
                isFetchingData={isFetchingData}
            />
            {Boolean(url) && !Boolean(isEditor) && (
                <DialogShareButtonGroup url={url} open={open} onClose={() => setOpen(false)} />
            )}
            {showError && (
                <DialogSystem
                    title={i18n.t('label.shared_url_error')}
                    body={i18n.t('label.shared_or_not_auth')}
                    closePopup={() => setShowError(false)}
                />
            )}
        </>
    );
};

export default OtherShareButton;

OtherShareButton.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string
};

const otherButtonStyle = variant => css`
    color: ${system900.color};
    border-color: ${variant === 'outlined' ? system300.color : ''};
    padding: 10px;
`;
